import Alphanumeric from '../../Projects/alphanumeric.mdx';
import Poster from  '../../Projects/dspathposter.mdx';
import KooriAdventure from '../../Projects/rpgGameKooriAdventure.mdx'; 

const ProjectLinks = [
    {
        id: 0,
        href: 'alphanumeric-handwriting-detector',
        content: Alphanumeric, 
    },
    {
        id: 1,
        href: 'dspath-ucr-monet-poster',
        content: Poster,
    },
    {
        id: 2,
        href: 'rpg-game-koori-adventure',
        content: KooriAdventure,
    }
];

export default ProjectLinks; 